import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import useEntityParams from './useEntityParams';
import V3EntityAppContext from '../../V3/Workspace/screens/EntityAppScreen/V3EntityAppContext';

const useSelectedEntity = (entity: EntityDetails.Entity | undefined) => {
  const v3EntityAppContext = useContext(V3EntityAppContext);
  const { value: paramValue } = useEntityParams();

  const value = useMemo(() => {
    if (v3EntityAppContext) {
      return v3EntityAppContext.selectedEntity;
    }

    return paramValue;
  }, [paramValue, v3EntityAppContext]);

  const getSelectedEntity = useCallback(():
    | EntityDetails.SelectedEntity
    | undefined => {
    if (!entity || !value) {
      return undefined;
    }

    return {
      type: entity,
      fieldValue: value,
    };
  }, [entity, value]);

  const [selectedEntity, setSelectedEntity] = useState<
    EntityDetails.SelectedEntity | undefined
  >(getSelectedEntity());

  useEffect(() => {
    setSelectedEntity(getSelectedEntity());
  }, [getSelectedEntity]);

  const onEntitySelected = useCallback((newEntity: string) => {
    setSelectedEntity((current) => {
      if (current === undefined) {
        return current;
      }

      return {
        ...current,
        fieldValue: newEntity,
      };
    });
  }, []);

  return {
    selectedEntity,
    onEntitySelected,
  };
};

export default useSelectedEntity;
